import { BroadcastChannel } from 'broadcast-channel';
import { ALFA_ID_CHANNEL } from 'src/components/AuthNew/hooks/constants';
import type { AlfaAuthResult } from 'src/components/AuthNew/hooks/useAlfaAuth';
import { getPathFromStateBase64 } from './utils';

export const AlfaHandler = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state') || '';
  const error = urlParams.get('error');

  const isWebView = window.is_webview || false;
  const pathFromState = getPathFromStateBase64(state);

  const handleRedirectFlow = () => {
    // TODO после того, как отроется wl-главная в Нексте, заменить фолбэк путь на '/'
    const targetPath = pathFromState || '/main';
    const newUrl = new URL(`${window.location.origin}${targetPath}`);

    if (code) {
      // Успешная авторизация - передаем code и state
      newUrl.searchParams.set('code', code);
      newUrl.searchParams.set('state', state);
    } else if (!isWebView) {
      // Если не WebView и нет code - добавляем error
      newUrl.searchParams.set('error', error || 'auth_failed');
    }
    // Для WebView без code - просто редиректим без параметров
    window.location.replace(newUrl.toString());
  };

  const handleBrowserFlow = () => {
    const channel = new BroadcastChannel(ALFA_ID_CHANNEL);
    if (code) {
      const result: AlfaAuthResult = {
        success: true,
        payload: {
          code,
          state,
          redirect_url: `${window.location.origin}/login/alfabank`,
        },
      };
      channel.postMessage(result);
    } else {
      const result: AlfaAuthResult = {
        success: false,
        payload: {
          error: error || 'неизвестная ошибка',
          state,
        },
      };
      channel.postMessage(result);
    }

    channel.close();
    setTimeout(() => {
      window.close();
    }, 250);
  };

  if (isWebView || pathFromState) {
    handleRedirectFlow();
  } else {
    handleBrowserFlow();
  }
};
